"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _components = require("../../components");

var _MigrationBox = require("../components/MigrationBox");

var _MigrationBox2 = _interopRequireDefault(_MigrationBox);

var _SubscriptionSuccessBox = require("../components/SubscriptionSuccessBox");

var _SubscriptionSuccessBox2 = _interopRequireDefault(_SubscriptionSuccessBox);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _EpicMigration = require("./EpicMigration.scss");

var _EpicMigration2 = _interopRequireDefault(_EpicMigration);

var _payments = require("../../redux/modules/payments");

var paymentActions = _interopRequireWildcard(_payments);

var _auth = require("../../redux/modules/auth");

var _selectors = require("../selectors");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EpicMigration = function (_React$Component) {
  (0, _inherits3.default)(EpicMigration, _React$Component);

  function EpicMigration(props) {
    (0, _classCallCheck3.default)(this, EpicMigration);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EpicMigration.__proto__ || (0, _getPrototypeOf2.default)(EpicMigration)).call(this, props));

    _this.handleSubscribeToUnrealUnlimited = _this.handleSubscribeToUnrealUnlimited.bind(_this);

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(EpicMigration, [{
    key: "handleSubscribeToUnrealUnlimited",
    value: function handleSubscribeToUnrealUnlimited() {
      var _this2 = this;

      var _props = this.props,
          subscribeToUnrealUnlimited = _props.subscribeToUnrealUnlimited,
          hasActiveSubscription = _props.hasActiveSubscription,
          hasActiveLegacySubscription = _props.hasActiveLegacySubscription,
          shouldUpdateEula = _props.shouldUpdateEula,
          acceptEULA = _props.acceptEULA;


      this.setState({
        subscribing: true
      });

      if (shouldUpdateEula) {
        acceptEULA().then(function () {
          subscribeToUnrealUnlimited().then(function () {
            _this2.setState({
              subscribing: false,
              subscribed: true
            });
          }).catch(function (error) {
            _this2.setState({
              subscribing: false,
              subscriptionError: error
            });
          });
        });
      } else {
        subscribeToUnrealUnlimited().then(function () {
          _this2.setState({
            subscribing: false,
            subscribed: true
          });
        }).catch(function (error) {
          _this2.setState({
            subscribing: false,
            subscriptionError: error
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          router = _props2.router,
          isLoading = _props2.isLoading,
          hasActiveLegacySubscription = _props2.hasActiveLegacySubscription,
          hasActiveSubscription = _props2.hasActiveSubscription,
          isEpicLogin = _props2.isEpicLogin,
          hasUnrealLicense = _props2.hasUnrealLicense,
          hasUnrealUnlimitedSubscription = _props2.hasUnrealUnlimitedSubscription,
          shouldUpdateEula = _props2.shouldUpdateEula,
          eulaLoading = _props2.eulaLoading;
      var _state = this.state,
          subscribing = _state.subscribing,
          subscribed = _state.subscribed,
          subscriptionError = _state.subscriptionError;
      var location = router.location;
      var state = location.state;

      var modal = state ? state.modal : false;
      var fromBanner = state ? state.fromBanner : false;
      var fromPricing = state ? state.fromPricing : false;
      var welcome = state ? state.welcome : false;

      var showEpicSubscription = !isEpicLogin || isEpicLogin && shouldUpdateEula || isEpicLogin && hasActiveSubscription || fromPricing || fromBanner;
      var showSwitchingPlans = !hasActiveSubscription && !shouldUpdateEula && (fromBanner ? true : fromPricing ? false : true);

      console.log(isEpicLogin && shouldUpdateEula && !hasActiveLegacySubscription && !fromPricing, welcome);

      return _react2.default.createElement(
        "div",
        { className: !modal ? _EpicMigration2.default.page : null },
        !modal ? _react2.default.createElement(_components.SiteHeaderGap, null) : null,
        _react2.default.createElement(
          "div",
          { className: _EpicMigration2.default.popupBox },
          !eulaLoading ? _react2.default.createElement(
            "div",
            null,
            hasUnrealUnlimitedSubscription || subscribed ? _react2.default.createElement(_SubscriptionSuccessBox2.default, null) : _react2.default.createElement(_MigrationBox2.default, {
              isLoading: isLoading,
              subscriptionError: subscriptionError,
              hasActiveLegacySubscription: hasActiveLegacySubscription,
              isEpicLogin: isEpicLogin,
              hasUnrealLicense: hasUnrealLicense,
              showEpicSubscription: showEpicSubscription,
              showSwitchingPlans: showSwitchingPlans,
              subscribeToUnrealUnlimited: this.handleSubscribeToUnrealUnlimited,
              subscribing: subscribing,
              shouldUpdateEula: shouldUpdateEula,
              welcome: welcome || isEpicLogin && shouldUpdateEula && !hasActiveSubscription && !fromPricing
            })
          ) : _react2.default.createElement(
            "div",
            { className: _EpicMigration2.default.preloaderWrap },
            _react2.default.createElement(_Preloader2.default, null)
          )
        )
      );
    }
  }]);
  return EpicMigration;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    isLoading: (0, _selectors.selectIsLoading)(state),
    hasActiveSubscription: (0, _selectors.selectHasActiveSubscription)(state),
    hasActiveLegacySubscription: (0, _selectors.selectHasActiveLegacySubscription)(state),
    hasUnrealUnlimitedSubscription: (0, _selectors.selectHasUnrealUnlimitedSubscription)(state),
    isEpicLogin: (0, _selectors.selectIsEpicLogin)(state),
    hasUnrealLicense: (0, _selectors.selectHasUnrealLicense)(state),
    shouldUpdateEula: state.auth.eula.updateVersion,
    eulaLoading: state.auth.eula.loading
  };
}, {
  subscribeToUnrealUnlimited: paymentActions.subscribeToUnrealUnlimited,
  acceptEULA: _auth.acceptEULA
})(EpicMigration);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/pages/EpicMigration.jsx
// module id = 2929
// module chunks = 0